import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { init } from '@tma.js/sdk';
import App from './app/App';
import './styles/index.css';
import { detectPlatform } from './app/core/environment/detector';
import { PlatformProvider } from './app/core/environment/PlatformContext';
import { TelegramProvider } from './app/core/telegram/TelegramContext';
import { ThemeProvider } from './app/core/ui/theme/ThemeProvider';
import { LanguageProvider } from "@/app/core/ui/theme/LanguageProvider";

// Инициализация TMA.js SDK
try {
  init();
} catch (error) {
  console.warn('TMA.js SDK инициализация:', error);
}



// Определяем платформу
const platform = detectPlatform();


// ===== Мок fetch с fallback =====
/*function setupGlobalMockFetch() {
  if (!import.meta.env.DEV) return;

  const originalFetch = window.fetch.bind(window);

  // --- Мок-ответы для платёжных и связанных эндпоинтов ---
  const mockResponses: Record<string, any> = {
    // Профиль
    '/api/v1/miniapp/user/profile': {
      data: {
        telegramId: 12345,
        firstName: 'Dev',
        lastName: 'User',
        userName: 'dev_user',
        currentTokens: 500,
        telegramPremium: true,
        subscriptionLevel: 'pro',
        photoUrl: 'https://picsum.photos/200',
        appSubscription: {
          id: 1,
          userId: 1,
          level: 'pro',
          price: 299,
          description: 'Mock Pro Plan',
          isActive: true,
          startDate: new Date().toISOString(),
          durationDays: 30,
          advantages: {},
          isValid: true,
          status: 'active',
          tokensRenewPerDay: 10,
        },
      },
    },
    // Баланс
    '/api/v1/miniapp/user/balance': {
      data: 500,
    },
    // Пакеты токенов
    '/api/v1/miniapp/catalog/token-packages': {
      data: [
        {
          id: 1,
          name: 'Starter',
          tokens: 100,
          priceRub: 199,
          planSegmentCode: 'starter',
        },
        {
          id: 2,
          name: 'Popular',
          tokens: 500,
          priceRub: 799,
          planSegmentCode: 'popular',
        },
        {
          id: 3,
          name: 'Max',
          tokens: 1500,
          priceRub: 1999,
          planSegmentCode: 'max',
        },
      ],
    },
    // Предпросмотр чекаута
    '/payments/checkout/preview': {
      data: {
        baseAmountMinor: 19900,
        finalAmountMinor: 19900,
        currency: 'RUB',
        referralDiscountMinor: 0,
        promoDiscountMinor: 0,
        promoCode: null,
      },
    },
    // Создание платежа (checkout)
    '/payments/checkout': {
      data: {
        paymentId: 1001,
        paymentLink: 'https://t.me/your_bot?start=payment_mock_1001',
        status: 'pending',
      },
    },
    // Статус платежа
    '/payments/': {
      data: {
        paymentId: 1001,
        status: 'completed', // или 'pending'
        amount: 199,
        currency: 'RUB',
      },
    },
  };

  // Флаг принудительного использования моков (можно переопределить в .env.development)
  const forceMocks = import.meta.env.VITE_USE_PAYMENT_MOCKS === 'true';

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;

    // Если принудительно используем моки, возвращаем их для соответствующих URL
    if (forceMocks) {
      for (const [key, mockData] of Object.entries(mockResponses)) {
        if (url.includes(key)) {
          console.log(`[MockFetch] Возвращаем мок для ${url}`);
          return new Response(JSON.stringify(mockData), {
            status: 200,
            headers: { 'Content-Type': 'application/json' },
          });
        }
      }
    }

    // Иначе пробуем реальный запрос, при ошибке – мок
    try {
      const response = await originalFetch(input, init);
      if (response.status < 500) return response;
      throw new Error(`Server error: ${response.status}`);
    } catch (error) {
      for (const [key, mockData] of Object.entries(mockResponses)) {
        if (url.includes(key)) {
          console.log(`[MockFetch] Бэк недоступен, возвращаем мок для ${url}`);
          return new Response(JSON.stringify(mockData), {
            status: 200,
            headers: { 'Content-Type': 'application/json' },
          });
        }
      }
      throw error;
    }
  };

  console.log('✅ Мок fetch с платёжными эндпоинтами активирован');
}*/

//setupGlobalMockFetch();

// Рендерим приложение
const rootElement = document.getElementById('app');
if (!rootElement) {
  throw new Error('Root element #app not found');
}

const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <PlatformProvider platform={platform}>
      <TelegramProvider>
        <ThemeProvider>
           <LanguageProvider>
              <App/>
          </LanguageProvider>
        </ThemeProvider>
      </TelegramProvider>
    </PlatformProvider>
  </StrictMode>
);